import React, { useContext, useEffect, useRef } from 'react'
import { Context } from '@/components/Context'
import { shortAddress } from '@/utils/shortenAddress'
import { ArtData } from '@/database/art'
import { formatTime } from '@/utils/formatting'
import { ChatMessage } from '@/types/websocket'

const ChatBody = ({ artData }: { artData?: ArtData }) => {
    const { currentAccount, messages, typingStatus } = useContext(Context)
    const lastMessageRef = useRef<HTMLDivElement>(null)
    const chatContainerRef = useRef<HTMLDivElement>(null)

    // Filter messages by the specific tag
    const filteredMessages = messages.filter((message: ChatMessage) =>
        !artData
            ? true
            : message?.tags?.includes(`@` + artData?.art.id) || message?.tags?.includes(`#` + artData?.tokenId),
    )

    useEffect(() => {
        if (chatContainerRef.current && lastMessageRef.current) {
            const chatContainer = chatContainerRef.current
            chatContainer.scrollTop = chatContainer.scrollHeight
        }
    }, [filteredMessages])

    return (
        <>
            <div ref={chatContainerRef} className="message__container height160">
                {filteredMessages.map((message: ChatMessage, index: number) =>
                    message?.name === `${shortAddress(currentAccount ?? '')}` ? (
                        <div
                            className={`smallest menu-wrapper-row ${index % 2 === 0 ? 'message-even' : 'message-odd'}`}
                            key={artData ? message.messageId : message.id}
                        >
                            <span className="gray">
                                ({formatTime(~~(+new Date() / 1000) - message.timestamp)}&nbsp;ago)&nbsp;You:&nbsp;
                            </span>
                            <span className="red-text">{message.text}</span>
                        </div>
                    ) : (
                        <div className="smallest menu-wrapper-row" key={artData ? message?.messageId : message?.id}>
                            <span className="dark-gray">
                                ({formatTime(~~(+new Date() / 1000) - message?.timestamp)}&nbsp;ago)&nbsp;
                                {message?.name}:&nbsp;
                            </span>
                            <span className="blue">{message?.text}</span>
                        </div>
                    ),
                )}
                <div ref={lastMessageRef}></div>
            </div>
            <div className="smallest menu-wrapper-row">
                {!artData && typingStatus && shortAddress(currentAccount ?? '') !== typingStatus ? (
                    <div>
                        <span className="white">{typingStatus}</span>
                        <span className="gray">&nbsp;is&nbsp;typing..</span>
                    </div>
                ) : (
                    <div>&nbsp;</div>
                )}
            </div>
        </>
    )
}

export default ChatBody
